const Notification = () => {
  return (
    <svg width={22} height={26} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.67 22.454C1.643 22.454 0 20.866 0 18.91c0-1.298.727-2.456 1.838-3.074l-.005-4.61c0-4.083 2.836-7.521 6.723-8.548v-.313C8.556 1.058 9.65 0 11 0c1.35 0 2.444 1.058 2.444 2.364v.313c3.888 1.026 6.723 4.465 6.723 8.555v4.613C21.279 16.466 22 17.62 22 18.91c0 1.96-1.641 3.546-3.67 3.546h-3.663C14.665 24.412 13.02 26 11 26c-2.025 0-3.667-1.586-3.667-3.543l-3.664-.003Zm6.108 0c0 .654.546 1.182 1.222 1.182.67 0 1.22-.53 1.222-1.181H9.778Zm7.944-11.222v5.71c0 .328.27.661.596.743l.32.08c.535.133.918.604.918 1.144 0 .653-.547 1.182-1.225 1.182H3.669c-.675 0-1.225-.531-1.225-1.182 0-.542.381-1.011.916-1.144l.332-.083a.803.803 0 0 0 .586-.74v-5.716c0-3.59 3.009-6.499 6.722-6.499 3.715 0 6.722 2.908 6.722 6.505Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Notification;
